import {
  ANNOUNCEMENT_DISMISSED,
  GET_ANNOUNCEMENTS_COMPLETED,
  GET_ANNOUNCEMENTS_ERROR,
} from "../constants";

import type { Announcement } from "models/announcements";
import type { ErrorDetails } from "models/ui";

export const getAnnouncementsCompleted = (announcements: Announcement[]) => ({
  payload: announcements,
  type: GET_ANNOUNCEMENTS_COMPLETED,
});

export const getAnnouncementsError = (error: ErrorDetails[]) => ({
  payload: error,
  type: GET_ANNOUNCEMENTS_ERROR,
});

export const dismissAnnouncement = (id: string) => ({
  payload: id,
  type: ANNOUNCEMENT_DISMISSED,
});
